import styled from 'styled-components';
import { remCalc } from 'src/components/base';

type RadioProps = { disabled?: boolean };
export const Radio = styled.div<RadioProps>`
  user-select: none;
  font-weight: normal;
  opacity: ${props => (props.disabled ? '0.5' : '1')};
`;

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

export const Input = styled.input`
  &:focus {
    border-color: ${p => p.theme.colors.base700};
  }
`;

export const LabelText = styled.span`
  display: flex;
  flex-direction: column;
  color: ${p => p.theme.colors.base700};
  padding-left: ${remCalc(6)};
`;

type HelperProps = { warning?: boolean };
export const Helper = styled.span<HelperProps>`
  font-size: ${remCalc(12)};
  width: 100%;
  color: ${p =>
    p.warning ? p.theme.colors.negative700 : p.theme.colors.base500};
`;
